import { render } from "./index.vue?vue&type=template&id=cc5a175e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=cc5a175e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-cc5a175e"

export default script